/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import MaterialTooltip from '@material-ui/core/Tooltip';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';

interface TooltipProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const StyledTooltip = styled((props) => (
  <MaterialTooltip
    classes={{
      popper: props.className,
      tooltipPlacementTop: 'tooltip-top'
    }}
    {...props}
  />
))`
  & {
    .MuiTooltip-tooltipPlacementTop {
      margin: 0px 0px ${Spacings.SPACING_1B} !important;
    }
  }
`;

const Tooltip: React.FC<TooltipProps> = ({ title, className, children }) => {
  return (
    <StyledTooltip title={title} placement="top-start" className={className}>
      <div>{children}</div>
    </StyledTooltip>
  );
};

Tooltip.displayName = 'Tooltip';

export default Tooltip;
